import React from "react";
import { motion } from "framer-motion";

const Stairs = ({ children }) => {
  const anim = (variants, custom = null) => {
    return {
      initial: "initial",
      animate: "enter",
      exit: "exit",
      variants,
      custom,
    };
  };

  const expand = {
    initial: {
      top: 0,
    },
    enter: (i) => ({
      top: "100%",
      height: "0%",
      height: "0%",
      transition: {
        delay: 0.25 + 0.05 * i,
        duration: 0.4,
        ease: [0.215, 0.61, 0.355, 1],
      },
      transitionEnd: {
        height: 0,
        top: 0,
      },
    }),
    exit: (i) => ({
      height: "100%",
      transition: {
        delay: 0.05 * i,
        duration: 0.4,
        ease: [0.215, 0.61, 0.355, 1],
      },
    }),
  };

  const overlay = {
    initial: {
      opacity: 0.5,
    },
    enter: {
      opacity: 0,
    },
    exit: {
      opacity: 0.5,
    },
  };

  const nbOfColumns = 5;

  return (
    <div className="page stairs overflow-hidden min-h-screen">
      <motion.div {...anim(overlay)} className="background" />
      <div className="transition-container">
        {[...Array(nbOfColumns)].map((_, i) => {
          return (
            <motion.div
              className=""
              {...anim(expand, nbOfColumns - i)}
              key={i}
            />
          );
        })}
      </div>

      {children}
    </div>
  );
};

export default Stairs;
